import { asyncLocalStorage } from '@/helpers/localStorage'
import UserModel from '@/models/User'

const state = {
  userInfo: JSON.parse(localStorage.getItem('userInfo')),
  userLoadStatus: false
}

const getters = {
  userInfo (state) {
    return state.userInfo
  },
  userLoadStatus (state) {
    return function () {
      return state.userLoadStatus
    }
  },
  checkPermission: (state, getters) => (permission, permissionType) => {
    return typeof state.userInfo[permissionType] !== 'undefined' ? state.userInfo[permissionType].indexOf(permission) !== -1 : false
  },
  hasCompanyPermission: (state, getters) => (permission) => {
    return getters.checkPermission(permission, 'companyPermissions')
  },
  hasUserPermission: (state, getters) => (permission) => {
    if (typeof permission === 'undefined' || getters.isManager) {
      return true
    }
    return getters.checkPermission(permission, 'permissions')
  },
  hasPermission: (state, getters) => (userPermission, companyPermission) => {
    if (state.userInfo === null) {
      return false // means it is not logged in
    }

    if (typeof companyPermission !== 'undefined') {
      return getters.hasCompanyPermission(companyPermission) && getters.hasUserPermission(userPermission)
    }

    return getters.hasUserPermission(userPermission)
  },
  isManager (state) {
    return state.userInfo !== null && state.userInfo.role === 'manager'
  },
  isAdmin (state) {
    return state.userInfo !== null && state.userInfo.role === 'admin'
  },
  isAgent (state) {
    return state.userInfo !== null && state.userInfo.role === 'agent'
  }
}

const mutations = {
  SET_USER_INFO (state, userInfo) {
    state.userInfo = userInfo
  },
  SET_USER_LANGUAGE (state, lang) {
    state.userInfo.language = lang
  },
  SET_USER_LOAD_STATUS (state, userLoadStatus) {
    state.userLoadStatus = userLoadStatus
  },
  SET_QUEUE_REPORT_STATUS (state, userQueueReportStatus) {
    state.userInfo.queue_report_status = userQueueReportStatus
  }
}

const actions = {
  async setUserInfo ({ commit }, userInfo) {
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
    commit('SET_USER_INFO', userInfo)
  },

  setUserLanguage ({ commit, getters }, lang) {
    commit('SET_USER_LANGUAGE', lang)
    localStorage.setItem('userInfo', JSON.stringify(getters.userInfo))
  },

  setUserQueueReportStatus ({ commit, getters }, queue_report_status) {
    commit('SET_QUEUE_REPORT_STATUS', queue_report_status)
    localStorage.setItem('userInfo', JSON.stringify(getters.userInfo))
  },

  // NOTE: Not being used, as login do not use router redirect.
  async loadUser ({ commit }) {
    const response = await UserModel.checkUser()

    const userData = response.data.user

    // TODO: Fix this on backend
    userData.role = response.data.role
    userData.permissions = response.data.permissions
    userData.company = response.data.company
    userData.loginType = response.data.loginType

    await asyncLocalStorage.setItem('userInfo', JSON.stringify(userData))
    await commit('SET_USER_INFO', userData)

    return userData
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
